/**
 * CHUYEN HE TOA DO - tap trung mot cho duy nhat.
 *
 * PDF: goc DUOI-TRAI, y huong LEN, don vi point (1/72 inch).
 * DOM: goc TREN-TRAI, y huong XUONG, don vi CSS pixel.
 *
 * Moi lan doi he deu phai di qua day. Ly do co module rieng cho sau dong toan:
 * lan nao co nguoi "tien tay" tru y truc tiep trong mot component la lan do
 * sinh ra mot loi lech mot pixel khong ai tim ra.
 */
import type { PdfRect } from '@pdfeditor/types';

export interface PageGeometry {
  widthPt: number;
  heightPt: number;
  rotation: 0 | 90 | 180 | 270;
  zoom: number;
}

/** Kich thuoc trang tren man hinh, DA tinh do xoay. */
export function displaySize(geo: PageGeometry): { width: number; height: number } {
  const swapped = geo.rotation === 90 || geo.rotation === 270;
  const w = swapped ? geo.heightPt : geo.widthPt;
  const h = swapped ? geo.widthPt : geo.heightPt;
  return { width: w * geo.zoom, height: h * geo.zoom };
}

export interface CssRect {
  left: number;
  top: number;
  width: number;
  height: number;
}

/** Hinh chu nhat trong toa do PDF -> hinh chu nhat trong toa do DOM. */
export function pdfRectToCss(rect: PdfRect, geo: PageGeometry): CssRect {
  const { widthPt: W, heightPt: H, rotation, zoom } = geo;
  const x0 = rect.x;
  const y0 = rect.y;
  const x1 = rect.x + rect.width;
  const y1 = rect.y + rect.height;

  // Bon goc sau khi xoay, tinh trong don vi point cua khung nhin da xoay.
  let left: number;
  let top: number;
  let width: number;
  let height: number;

  switch (rotation) {
    // /Rotate 90 = xoay THEO CHIEU KIM DONG HO 90 do khi hien thi. Goc duoi-trai
    // cua PDF di len goc tren-trai cua man hinh, nen cssX = y va cssY = x.
    // Doi chieu voi ma tran PageViewport cua pdf.js: rotation 90 -> [0,1,1,0,0,0].
    case 90:
      left = y0;
      top = x0;
      width = y1 - y0;
      height = x1 - x0;
      break;
    case 180:
      left = W - x1;
      top = y0;
      width = x1 - x0;
      height = y1 - y0;
      break;
    // pdf.js rotation 270 -> [0,-1,-1,0, H, W]: cssX = H - y, cssY = W - x.
    case 270:
      left = H - y1;
      top = W - x1;
      width = y1 - y0;
      height = x1 - x0;
      break;
    case 0:
    default:
      left = x0;
      top = H - y1;
      width = x1 - x0;
      height = y1 - y0;
      break;
  }

  return {
    left: left * zoom,
    top: top * zoom,
    width: width * zoom,
    height: height * zoom,
  };
}

/** Diem trong toa do DOM (tuong doi voi goc trang) -> toa do PDF. */
export function cssPointToPdf(
  px: number,
  py: number,
  geo: PageGeometry,
): { x: number; y: number } {
  const { widthPt: W, heightPt: H, rotation, zoom } = geo;
  const ux = px / zoom;
  const uy = py / zoom;
  switch (rotation) {
    case 90:
      return { x: uy, y: ux };
    case 180:
      return { x: W - ux, y: uy };
    case 270:
      return { x: W - uy, y: H - ux };
    case 0:
    default:
      return { x: ux, y: H - uy };
  }
}
